import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
const TimePickerTheme = {
    timePicker: {
        light: {
            fontSize: FontSizes.large,
            lineHeight: LineHeights.large,
            states: {
                enabled: {
                    borderColor: withOpacity(Colors.black, Opacities.xLow),
                    color: Colors.black,
                },
                disabled: {
                    borderColor: withOpacity(Colors.black, Opacities.low),
                    color: withOpacity(Colors.black, Opacities.low),
                },
            },
        },
        dark: {
            fontSize: FontSizes.large,
            lineHeight: LineHeights.large,
            states: {
                enabled: {
                    borderColor: withOpacity(Colors.white, Opacities.xLow),
                    color: Colors.white,
                },
                disabled: {
                    borderColor: withOpacity(Colors.white, Opacities.low),
                    color: withOpacity(Colors.white, Opacities.low),
                },
            },
        },
    },
};
export default TimePickerTheme;
